import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';

import I18n from 'PMT/i18n/I18n';

// -- entities
import ProductCategory from 'PMT/entities/menu/ProductCategory';
import RestaurantMenu from 'PMT/entities/menu/RestaurantMenu';

// -- constants
import Events from 'constants/Events';

// -- stores
import RestaurantMenuStore from 'stores/RestaurantMenuStore';

// -- views
import { Modal } from 'react-bootstrap';
import AddItemToCategoryView from './AddItemToCategoryView';

export default class AddItemToCategoryModal extends Component {

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,

    productCategory: PropTypes.instanceOf(ProductCategory),

    restaurantMenu: PropTypes.instanceOf(RestaurantMenu)
  };

  componentDidMount() {
    RestaurantMenuStore.addListener(Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onChange);
  }

  shouldComponentUpdate(nextProps: Object) {
    return nextProps.show !== this.props.show
        // an update have been made
      || !nextProps.restaurantMenu.equals(this.props.restaurantMenu)
      || this.props.productCategory.equals(nextProps.productCategory);
  }

  componentWillUnmount() {
    RestaurantMenuStore.removeListener(Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onChange);
  }

  onChange = () => {
    this.props.onHide();
  };

  onHide = () => {
    this.props.onHide();
  };

  onClose = () => {
    this.props.onHide();
  };

  render() {
    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={this.onHide}
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.onClose}
          >
            <span aria-hidden="true">×</span>
          </button>

          <Modal.Title>
            {I18n.tr('menu.category.add_item.modal_title')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddItemToCategoryView
            productCategory={this.props.productCategory}
            restaurantMenu={this.props.restaurantMenu}
          />
        </Modal.Body>
      </Modal>
    );
  }
}
